import {
  Directive,
  effect,
  EmbeddedViewRef,
  inject,
  input,
  signal,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { Candidate } from '@recruitee/candidate-types';

import { KiwiHrPromoService } from './kiwi-hr-promo.service';

@Directive({
  selector: '[rtKiwiHrPromoGuard]',
  standalone: true,
})
export class KiwiHrPromoGuardDirective {
  private readonly kiwiHrPromoService = inject(KiwiHrPromoService);
  private readonly vcRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef);

  public candidate = input(null, {
    alias: 'rtKiwiHrPromoGuard',
    transform: (candidate: Candidate | null | '') => candidate || null,
  });

  private embeddedViewRef = signal<EmbeddedViewRef<any> | null>(null);

  private watchEmbeddedCmpInputChanges = effect(() => this.embeddedViewRef()?.detectChanges());

  private showOrHidePromo$ = this.kiwiHrPromoService
    .isPromoVisible(toObservable(this.candidate))
    .pipe(takeUntilDestroyed())
    .subscribe(showPromo => {
      this.vcRef.clear();
      const view = showPromo ? this.vcRef.createEmbeddedView(this.templateRef) : null;
      this.embeddedViewRef.set(view);
    });
}
